module.exports = __webpack_public_path__ + "static/assets/3de2eae1d69926d971c7a345aee8755b.png";